import type { User } from '@/types';
import { demoUser } from './account';

/**
 * MOCK identities. The email chooses the role so every guard can be exercised without a backend.
 * Real auth (JWT + refresh tokens, RBAC from the DB) replaces this in the backend phase.
 */
const staffDirectory: Record<string, Omit<User, 'email'>> = {
  'admin@demo-commerce.store': { id: 'usr_admin', name: 'Meera Kapoor', role: 'TENANT_ADMIN', tenantId: 'tenant_demo', memberSince: '2025-06-01T00:00:00Z' },
  'owner@demo-commerce.store': { id: 'usr_owner', name: 'Vikram Rao', role: 'TENANT_OWNER', tenantId: 'tenant_demo', memberSince: '2025-05-01T00:00:00Z' },
  'staff@demo-commerce.store': { id: 'usr_staff', name: 'Rohan Das', role: 'STAFF', tenantId: 'tenant_demo', memberSince: '2025-09-12T00:00:00Z' },
  'super@mce.dev': { id: 'usr_super', name: 'Platform Admin', role: 'SUPER_ADMIN', tenantId: 'platform', memberSince: '2025-01-01T00:00:00Z' },
  'owner@northwind.test': { id: 'usr_nw_owner', name: 'Northwind Owner', role: 'TENANT_OWNER', tenantId: 'tenant_northwind', memberSince: '2026-01-01T00:00:00Z' },
  'owner@urbanthreads.test': { id: 'usr_ut_owner', name: 'Ananya Rao', role: 'TENANT_OWNER', tenantId: 'tenant_urbanthreads', memberSince: '2026-03-10T00:00:00Z' },
  'owner@greenleaf.test': { id: 'usr_gl_owner', name: 'Karthik Iyer', role: 'TENANT_OWNER', tenantId: 'tenant_greenleaf', memberSince: '2026-09-10T00:00:00Z' },
  'owner@technest.test': { id: 'usr_tn_owner', name: 'Priyanka Shah', role: 'TENANT_OWNER', tenantId: 'tenant_technest', memberSince: '2025-11-20T00:00:00Z' },
  'owner@fitfuel.test': { id: 'usr_ff_owner', name: 'Rajesh Kumar', role: 'TENANT_OWNER', tenantId: 'tenant_fitfuel', memberSince: '2026-02-01T00:00:00Z' },
};

export const DEMO_ACCOUNTS = [
  { email: 'admin@demo-commerce.store', role: 'Store admin', note: 'Full merchant admin' },
  { email: 'staff@demo-commerce.store', role: 'Staff', note: 'Limited permissions' },
  { email: 'owner@northwind.test', role: 'Other tenant owner', note: 'Separate tenant data' },
  { email: 'super@mce.dev', role: 'Platform admin', note: 'Runs /super-admin' },
];

export const isStaffEmail = (email: string) => email.trim().toLowerCase() in staffDirectory;

export function userForEmail(email: string): User {
  const key = email.trim().toLowerCase();
  if (!key.includes('@')) return structuredClone(demoUser); // legacy/blank session value
  const staff = staffDirectory[key];
  if (staff) return { ...staff, email: key };
  return { ...structuredClone(demoUser), email: key };
}
